import React from 'react';

const AdminSidebar = ({ activeTab, setActiveTab, sidebarOpen, setSidebarOpen, adminData }) => {
  const menuItems = [
    { id: 'dashboard', name: 'Dashboard', icon: '📊' },
    { id: 'matches', name: 'Matches', icon: '⚽' },
    { id: 'match-api-settings', name: 'Match API Settings', icon: '🌐' },
    { id: 'conveyor-items', name: 'Sell Page Items', icon: '🏪' }, 
    { id: 'flags', name: 'Flag Management', icon: '🏳️' },
    { id: 'players', name: 'Player Management', icon: '🎨' },
    { id: 'review-players', name: 'Review Players', icon: '⭐' },
    { id: 'categories', name: 'Quiz Categories', icon: '📁' },
    { id: 'quiz', name: 'Quiz Management', icon: '❓' },
    { id: 'pool-settings', name: 'Quiz Pool Settings', icon: '🔄' },
    { id: 'quiz-results', name: 'Quiz Results', icon: '📈' },
    { id: 'leaderboard', name: 'Leaderboard', icon: '🏆' },
    { id: 'fun-dilemmas', name: 'Fun Dilemmas', icon: '🤔' },
    { id: 'country-battle-teams', name: 'Country Teams', icon: '🌍' },
    { id: 'adstra-settings', name: 'Adstra Settings', icon: '📢' },
    { id: 'adsense-settings', name: 'AdSense Settings', icon: '💰' },
    { id: 'suggestions', name: 'Suggestions', icon: '💡' }, // ADDED: Suggestions menu item
    { id: 'admins', name: 'Admin Management', icon: '👥' },
    { id: 'password', name: 'Change Password', icon: '🔒' },
  ];

  return (
    <>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}>
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-800">Sports Admin</h2>
            <button
              className="lg:hidden p-1 rounded-md text-gray-400 hover:text-gray-500"
              onClick={() => setSidebarOpen(false)}
            >
              ✕
            </button>
          </div>

          {/* Admin info */}
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold">
                {adminData?.username?.charAt(0)?.toUpperCase()}
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900">{adminData?.username}</p>
                <p className="text-xs text-gray-500 capitalize">{adminData?.role}</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  setActiveTab(item.id);
                  setSidebarOpen(false);
                }}
                className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  activeTab === item.id
                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <span className="text-lg mr-3">{item.icon}</span>
                {item.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;
